import { LoadablePaint } from '@confluence/loadable';

export const SearchPage = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-SearchPage" */ './SearchPage.tsx'))
			.ConfluenceSearchPage,
});
